import * as React from 'react';
import styled from 'styled-components';
import { Block, Icon } from '../../../../components';
import BoxContainer from './BoxContainer';
import closeIcon from '../../../../../assets/icons/icon-close-red.svg';

interface ModalScheduleProps {
  showModal: boolean;
  handleClose: () => void;
}

export const CloseButton = styled.button.attrs((props: any) => ({
  padding: props.padding
}))`
  display: flex;
  align-items: center;
  padding: 0px 8px;
  padding: ${(props) => (props.padding ? props.padding : 'none')};
  border-radius: 4px;
  &:hover {
    background-color: #fed4d6;
  }
`;
const ModalConfirmation: React.FC<ModalScheduleProps> = (props) => {
  const { showModal, handleClose, children } = props;
  return (
    <BoxContainer IsModalOpen={showModal}>
      <Block
        width="100%"
        customized
        flexDirection="row"
        justifyContent="flex-end"
        padding="8px 4px 0px"
        data-testid="cmp-modal-confirmation"
        minHeight="auto"
      >
        <CloseButton
          type="button"
          data-testid="cmp-close-LightBox"
          onClick={handleClose}
        >
          <Icon
            customized
            minWidth="40px"
            height="40px"
            alignItems="center"
            justifyContent="center"
          >
            <img src={closeIcon} alt="other" />
          </Icon>
        </CloseButton>
      </Block>
      {children}
    </BoxContainer>
  );
};
export default ModalConfirmation;
